import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage8(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(
    refs.prayer.encouragementMsgContainerRef.current,
    {
      alpha: 0,
      duration: 1,
    },
    'stage8'
  );

  tl.to(
    refs.blobs.pink.current,
    {
      width: vw(0.85),
      height: vh(0.2),
      x: vw(0.05),
      y: vh(0.4),
      duration: 1,
    },
    'stage8'
  )
    .to(
      refs.blobs.cyan.current,
      {
        width: vw(1.24),
        height: vh(0.5),
        x: vw(-0.4),
        duration: 1,
      },
      'stage8'
    )
    .to(
      refs.buttons.action.current,
      {
        width: 162,
        height: 90,
        scale: 1,
        x: -30,
        borderRadius: '300px',
        boxShadow: '0 0 50px 11px rgba(255, 255, 255, 0)',
        duration: 1,
      },
      'stage8'
    )
    .to(
      refs.buttons.decor.current,
      {
        width: 162,
        height: 90,
        alpha: 1,
        x: 25,
        borderRadius: '300px',
        duration: 1,
      },
      'stage8'
    );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage8',
    animations: [
      { x: vw(0.218), y: vh(-0.198), duration: 1 },
      { x: vw(0.436), y: vh(-0.362), duration: 1 },
      { x: vw(-0.325), y: vh(-0.214), duration: 1 },
      { x: vw(0.355), y: vh(-0.587), duration: 1 },
      { x: vw(-0.061), y: vh(-0.624), duration: 1 },
      { x: vw(-0.454), y: vh(-0.52), duration: 1 },
    ],
  });
}
